import { render, staticRenderFns } from "./YoutubeWidget.vue?vue&type=template&id=9b7666b2&scoped=true"
import script from "./YoutubeWidget.vue?vue&type=script&lang=js"
export * from "./YoutubeWidget.vue?vue&type=script&lang=js"
import style0 from "./YoutubeWidget.vue?vue&type=style&index=0&id=9b7666b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7666b2",
  null
  
)

export default component.exports